//阿里云上传封装
import OSS from "ali-oss";
import { decrypt } from "@/utils/common";
import { preUpload } from "@/api/ei/eiMallApi";
import { v4 as uuidv4 } from 'uuid';
export async function uploads(option) {
  if (typeof XMLHttpRequest === "undefined") {
    return;
  }
  const headers = option.headers || {};
  const options = {
    // 获取分片上传进度、断点和返回值。
    progress: (p, cpt, res) => {
      option.onProgress(p, cpt, res);
    },
    // 设置并发上传的分片数量。
    parallel: 4,
    // 设置分片大小。默认值为1 MB，最小值为100 KB。
    partSize: 1024 * 1024,
    headers: {
      ...headers,
      // "Cache-Control": "no-cache",
      // 指定该Object被下载时的名称。
      // "Content-Disposition": "example.txt",
      // 指定该Object被下载时的内容编码格式。
      // "Content-Encoding": "utf-8",
      // 指定过期时间，单位为毫秒。
      // Expires: "1000",
      // 指定Object的存储类型。
      // "x-oss-storage-class": "Standard",
      // 指定Object标签，可同时设置多个标签。
      // "x-oss-tagging": "Tag1=1&Tag2=2",
      // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
      // "x-oss-forbid-overwrite": "false",
    },
    // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
    // meta: { year: new Date().getTime() },
    mime: option.file.type,
  };

  try {
    if(!option.aimPath){
      option.onError('请提供上传路径！');
    }
    let re = await preUpload();
    if(re.errno){
      option.onError(re.message);
      return false;
    }

    const authdata = JSON.parse(decrypt(re.data));

    let ossClient = new OSS({
      accessKeyId: authdata.access_key_id,
      accessKeySecret: authdata.access_key_secret,
      bucket: authdata.bucket,
      region: authdata.region,
      stsToken: authdata.security_token,
      cname: authdata.cname,
      secure: authdata.secure,
      endpoint: authdata.endpoint,
    });
    // 'abc'.lastIndexOf
    const name =
      option.aimPath + uuidv4().split('-').join('') + option.file.name.substring(option.file.name.lastIndexOf("."));
      // console.log('name', name);
    const res = ossClient.multipartUpload(name, option.file, {
      ...options,
    });
    return res;
  } catch (err) {
    option.onError(err);
  }
}
